import { ListItem, ListItemText, Stack } from "@mui/material";
import React from "react";
import { useDroppable } from "@dnd-kit/core";
import { AnimatePresence, motion } from "framer-motion";
import { useQuickLinksItems } from "../../../context/QuickLinksContext";
import { tabsData } from "../../../assets/data/data";

import {
  RootWrapper,
  EmptyStateBox,
  EmptyStateText,
  StyledList,
  StyledListItemButton,
  ItemText,
  StyledListItemIcon,
  StyledEastOutlined,
  StyledClose,
} from "./DroppableArea.styles";
import { EMPTY_STATE_TEXT } from "./DroppableArea.constants";

const DroppableArea = ({ droppedItems, setDroppedItems }) => {
  const { setNodeRef, isOver } = useDroppable({ id: "droppable" });
  const { setSelectedTab } = useQuickLinksItems();

  const handleRemove = (tab) => {
    const updatedDroppedItems = droppedItems.filter((i) => i !== tab);
    setDroppedItems(updatedDroppedItems);
    localStorage.setItem(
      "quickLinksItems",
      JSON.stringify(updatedDroppedItems)
    );
  };

  return (
    <RootWrapper ref={setNodeRef} isOver={isOver}>
      {droppedItems.length === 0 ? (
        <EmptyStateBox>
          <EmptyStateText>{EMPTY_STATE_TEXT}</EmptyStateText>
        </EmptyStateBox>
      ) : (
        <StyledList>
          <AnimatePresence>
            {droppedItems?.map((tab, index) => (
              <motion.div
                key={tab}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.3 }}
              >
                <ListItem disablePadding>
                  <StyledListItemButton key={index}>
                    <ListItemText
                      onClick={() => setSelectedTab(tab)}
                      primary={
                        <Stack direction="row" alignItems="center" spacing={2}>
                          <ItemText>
                            {tabsData.find((t) => t.id === tab)?.name}
                          </ItemText>
                          <StyledEastOutlined />
                        </Stack>
                      }
                    />
                    <StyledListItemIcon onClick={() => handleRemove(tab)}>
                      <StyledClose />
                    </StyledListItemIcon>
                  </StyledListItemButton>
                </ListItem>
              </motion.div>
            ))}
          </AnimatePresence>
        </StyledList>
      )}
    </RootWrapper>
  );
};

export default DroppableArea;
